import React from 'react';
import moment from 'moment';

import style from './style.css';

const Calendar = ({
  date,
  bgColor
}) => {
  return (
    <div className={style.calendar}>
      <div
        className={style.month}
        style={bgColor && { background: bgColor }}
      >
        {moment(date).format('MMM')}
      </div>
      <div className={style.day}>
      {moment(date).format('D')}
      </div>
    </div>
  );
};

// TODO: move to Flow types
// Calendar.propTypes = {
//   date: PropTypes.string,
//   bgColor: PropTypes.string
// };

export default Calendar;
